import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVueNext from 'bootstrap-vue-next'
import Multiselect from '@vueform/multiselect'
// CSS saja
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'vue3-carousel/dist/carousel.css'
import './assets/custom.scss'
import '@vueform/multiselect/themes/default.css'
// ❌ HAPUS baris-baris ini kalau masih ada:
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// import 'bootstrap/js/dist/offcanvas'
// import 'bootstrap/js/dist/dropdown'

const app = createApp(App)
app.use(router)
app.use(BootstrapVueNext)
app.component('UiMultiselect', Multiselect)
app.mount('#app')
